import request from '../../js/lib/request';
import envVar from '../../js/lib/envVar';
import currentLang from '../../js/lib/currentLang';

if (document.getElementById('prof-dev')) {

	// Use different URL for Static/MVC
	const url = envVar({
		backendPath:'/ProfDev/',
		staticPath: 'js/data/prof-dev.json'
	});

	//request().get(url).then(function(response) {
		// Vue Component
		Vue.config.devtools = true;
		const profDev = new Vue({
			// cards Element ~> this.$el
			el: '#prof-dev',
			// Define Schema ~> set to null/0
			data: {
                items:'',
				selected: {
					title: "Choose Your Path",
					subtitle: "Use the drop down selector (above) to select a professional development path. There are over 10 courses, 5 designations, and many online courses available."
				},
				selectedIndex: -1,
				isLoading: false
			},
			// When Component is Mounted, run Methods
			mounted: function() {
				const self = this;
				//self.loadItems();
			},
			// Methods
			methods: {
				loadItems: function() {
					const self = this;
					self.items = response;
				},
				selectItem: function(event) {
					const self = this;
                    this.isLoading = true;
                    document.getElementById('learning-path').innerHTML = '';

                    Vue.nextTick(function () {
                        var langParam = currentLang();
                        if (langParam)
                            langParam = "&lang=" + langParam;
                        request().get("/LearningPathBlock/GetBlockById?id=" + event.target.value + langParam).then(function (response) {
                            document.getElementById('learning-path').innerHTML = response;
                            self.selected = self.items[self.selectedIndex];
                            self.isLoading = false;
                        });
                    });
				},
				toggleCard: function(event) {
					/*console.log(event.currentTarget);
					var body = event.currentTarget.parentElement;
					console.log(body);
					if(body.getAttribute('data-open')) {
						body.removeAttribute('data-open');
					} else {
						body.setAttribute('data-open', true);
					}*/
				}
			}
		});
	//});
}


// WEBPACK FOOTER //
// ../components/loma-homepage/prof-dev.js